/* unplugin-vue-components disabled */import script from "./create_score.vue?vue&type=script&setup=true&lang=js"
export * from "./create_score.vue?vue&type=script&setup=true&lang=js"

import "./create_score.vue?vue&type=style&index=0&id=73783d47&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73783d47"]])

export default __exports__